"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUpDependencies = void 0;
const core = __importStar(require("@actions/core"));
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const APT_GET_INSTALL_BASE = 'sudo apt-get -y --no-upgrade install';
const COMPONENT_TO_DEPS = new Map([
    [
        'linux',
        new Map([
            ['nodejs', `${APT_GET_INSTALL_BASE} g++ make`],
            ['ruby', `${APT_GET_INSTALL_BASE} make gcc libssl-dev libz-dev`],
            [
                'R',
                `${APT_GET_INSTALL_BASE} libgomp1 build-essential gfortran libxml2 libc++-dev`
            ]
        ])
    ],
    ['darwin', new Map([['ruby', 'brew install openssl']])]
]);
function setUpDependencies(components) {
    return __awaiter(this, void 0, void 0, function* () {
        const platformDeps = COMPONENT_TO_DEPS.get(constants_1.GRAALVM_PLATFORM);
        if (platformDeps) {
            for (const component of components) {
                const depCommand = platformDeps.get(component);
                if (depCommand) {
                    core.startGroup(`Installing dependencies for ${component}...`);
                    yield (0, utils_1.exec)(depCommand);
                    core.endGroup();
                }
            }
        }
    });
}
exports.setUpDependencies = setUpDependencies;
